const UNITS_RESERVATIONS = {
  //getUnitOccupancy
  UNITS_UNIT_OCCUPANCY: 'UNITS_UNIT_OCCUPANCY',
  //getOccupancyPartners -> TBD change "source" also
  UNITS_OCCUPANCY_PARTNERS: 'UNITS_OCCUPANCY_PARTNERS',
  //getReservationsAndOccupancies
  UNITS_RESERVATIONS_AND_OCCUPANICES: 'UNITS_RESERVATIONS_AND_OCCUPANICES',
  //getReservationsAndOccupancies?EqualsTo[propertyId]
  UNITS_RESERVATIONS_AND_OCCUPANICES_EQUALS_TO_PROPERTY: 'UNITS_RESERVATIONS_AND_OCCUPANICES',
  //getCalendarReservations
  UNITS_CALENDAR_RESERVATIONS: 'UNITS_CALENDAR_RESERVATIONS',
  //getLineCalendarReservations
  LINE_CALENDAR_RESERVATIONS: 'LINE_CALENDAR_RESERVATIONS',
  //getLineCalendarPricesDiscounts
  LINE_CALENDAR_PRICES_DISCOUNTS: 'LINE_CALENDAR_PRICES_DISCOUNTS',
  //getReservations
  UNITS_RESERVATIONS: 'UNITS_RESERVATIONS',
  //getActivePriceList
  ACTIVE_PRICE_LIST: 'ACTIVE_PRICE_LIST',
  //getReservations?EqualsTo[dateFrom]
  UNITS_RESERVATIONS_EQUALS_TO_DATE_FROM: 'UNITS_RESERVATIONS_EQUALS_TO_DATE_FROM',
  //getReservations?EqualsTo[dateTo]
  UNITS_RESERVATIONS_EQUALS_TO_DATE_TO: 'UNITS_RESERVATIONS_EQUALS_TO_DATE_TO',
  //getReservations?EqualsTo[status]
  UNITS_RESERVATIONS_EQUALS_TO_STATUS: 'UNITS_RESERVATIONS_EQUALS_TO_STATUS',
  //getOccupancies
  UNITS_OCCUPANCIES: 'UNITS_OCCUPANCIES',

  //getReservationType
  UNITS_RESERVATION_TYPE: 'UNITS_RESERVATION_TYPE',
  //getEvisitorConnectionStatus
  UNITS_EVISITOR_CONNECTION_STATUS: 'UNITS_EVISITOR_CONNECTION_STATUS',
  //getPaymentInfo
  UNITS_RESERVATIONS_PAYMENTS_INFO: 'UNITS_RESERVATIONS_PAYMENTS_INFO',
  //getReservationPayments
  UNITS_RESERVATIONS_PAYMENTS: 'UNITS_RESERVATIONS_PAYMENTS',
  //getPaymentMethodsTypes
  UNITS_PAYMENT_METHOD_TYPES: 'UNITS_PAYMENT_METHOD_TYPES',
  //getReservationServices
  UNITS_RESERVATION_SERVICES: 'UNITS_RESERVATION_SERVICES',
  //getReservationTypeOfService
  UNITS_RESERVATION_TYPE_OF_SERVICE: 'UNITS_RESERVATION_TYPE_OF_SERVICE',
  //getReservationLanguages
  UNITS_RESERVATION_LANGUAGES: 'UNITS_RESERVATION_LANGUAGES',
  //calculate Reservation Services and discounts step 3
  CALCULATE_RESERVATION: 'CALCULATE_RESERVATION',
  //add or edit Reservation Services and discounts step 3
  CALCULATE_RESERVATION_UPSERT_SERVICES: 'CALCULATE_RESERVATION_UPSERT_SERVICES',
  // insert new guest, reservations step 4
  RESERVATION_INSERT_NEW_GUEST: 'RESERVATION_INSERT_NEW_GUEST',
  //insert new reservation, reservations step 4
  RESERVATION_INSERT_NEW_RESERVATION: 'RESERVATION_INSERT_NEW_RESERVATION',
  //insert new additional services from step 3 if there is any, reservations step 4
  RESERVATION_INSERT_NEW_ADDITIONAL_SERVICES: 'RESERVATION_INSERT_NEW_ADDITIONAL_SERVICES',
  //insert new additional discount services from step 3 if there is any, reservations step 4
  RESERVATION_INSERT_NEW_ADDITIONAL_DISCOUNT_SERVICES:
    'RESERVATION_INSERT_NEW_ADDITIONAL_DISCOUNT_SERVICES',
  // calculate payment installment in step 4
  RESERVATION_CALCULATE_PAYMENT_INSTALLMENT: 'RESERVATION_CALCULATE_PAYMENT_INSTALLMENT',
  //insert payment installment in step 4, Save and submit btn
  RESERVATION_INSERT_PAYMENT_INSTALLMENT: 'RESERVATION_INSERT_PAYMENT_INSTALLMENT',
  //getPropertyActivePaymentModels
  PROPERTY_ACTIVE_PAYMENT_MODELS: 'PROPERTY_ACTIVE_PAYMENT_MODELS',
  RESERVATIONS_PRICE_LIST_RULES_VALIDATION: 'RESERVATIONS_PRICE_LIST_RULES_VALIDATION',
  RESERVATION_PRICE_LIST_SERVICES: 'RESERVATION_PRICE_LIST_SERVICES',
  RESERVATION_EDIT_CONTRACTS: 'RESERVATION_EDIT_CONTRACTS',
  RESERVATION_NEW_CUSTOM_FILTER: 'RESERVATION_NEW_CUSTOM_FILTER',
  RESERVATION_NEW_CUSTOM_FILTER_DETAILS: 'RESERVATION_NEW_CUSTOM_FILTER_DETAILS',
  RESERVATION_R1_INVOICE_INFO: 'RESERVATION_R1_INVOICE_INFO',
  RESERVATION_R1_INVOICE_INFO_PARTNER_TYPES: 'RESERVATION_R1_INVOICE_INFO_PARTNER_TYPES',
  //getGuestMisconductFormData
  GUEST_MISCONDUCT_FORM_DATA: 'GUEST_MISCONDUCT_FORM_DATA',

  // getUnitOccupancy
  UNITS_RESERVATION_OCCUPANCY: 'UNITS_RESERVATION_OCCUPANCY',
  // getAtlasSessions
  ATLAS_SESSIONS: 'ATLAS_SESSIONS',
};

export default UNITS_RESERVATIONS;
